import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { FormControl } from "react-bootstrap";
import ReactDOM from "react-dom";
import _ from "lodash";
import $ from "jquery";

import AccountStore from "../stores/AccountStore";

import Api from "../utils/Api";

// TODO: BA-163 move me
const makeCancelable = (promise) => {
	let hasCanceled_ = false;

	const wrappedPromise = new Promise((resolve, reject) => {
		promise.then(
			val => hasCanceled_ ? reject({isCanceled: true}) : resolve(val),
			error => hasCanceled_ ? reject({isCanceled: true}) : reject(error)
		);
	});

	return {
		promise: wrappedPromise,
		cancel() {
			hasCanceled_ = true;
		},
	};
};

export default class DescriptionComplete extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = {
			selectedIndex: 0,
			expanded: false,
			dropUp: false,
			description: this.props.value || ""
		};

		this._outstandingRequests = [];
		this.fetchShownOptions = this.fetchShownOptions.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.handleKeyDown = this.handleKeyDown.bind(this);
		this.handleTextFieldChange = this.handleTextFieldChange.bind(this);
	}

	fetchShownOptions(value)
	{
		const selectedAccount = AccountStore.getSelected();
		if (!selectedAccount || !selectedAccount.id)
		{
			return;
		}

		const cancelablePromise = makeCancelable(Api.getRecentDescriptions(selectedAccount.id, value));
		cancelablePromise
			.promise
			.then(lineItemsReturned => {
				this.setState({
					shownOptions: lineItemsReturned,
					expanded: lineItemsReturned && lineItemsReturned.length > 0,
					dropUp: this.shouldDropUp()
				});
			}).catch(message => {
				console.error("Error getting recent descriptions.", message);
			});
		this._outstandingRequests.push(cancelablePromise);
	}

	shouldDropUp()
	{
		let dropUp = false;
		if (this.textInput)
		{
			const $input = $(ReactDOM.findDOMNode(this.textInput));
			if (($input.offset().top - $(window).scrollTop())/$(window).height() > 0.5)
			{
				dropUp = true;
			}
		}
		return dropUp;
	}

	handleOptionSelect(option)
	{
		this.props.onSelect(option);
		if (this.textInput)
		{
			_.defer(() => {
				ReactDOM.findDOMNode(this.textInput).focus();
			});
		}
	}

	handleTextFieldChange(event)
	{
		const description = event.target.value || "";
		const state = { description, selectedIndex: 0 };
		if (description.length >= 1) {
			this.fetchShownOptions(description);
		} else {
			state.expanded = false;
			state.shownOptions = null;
		}

		this.props.onChange(description);
		this.setState(state);
	}

	handleFocus(event)
	{
		this.props.onFocus(event);
	}

	handleBlur(event)
	{
		this.setState({expanded: false});
		this.props.onBlur(event);
	}

	handleKeyDown(event)
	{
		const expanded = this.state.expanded;
		const maxIndex = this.state.shownOptions ? this.state.shownOptions.length - 1 : 0;
		let selectedIndex = this.state.selectedIndex;
		let handled = false;
		let bubbleToPropsKeyDown = true;
		switch (event.key)
		{
			case "ArrowDown":
				if (!expanded)
				{
					if (this.state.description.length >= 3)
					{
						this.fetchShownOptions(this.state.description || "");
					}
				}
				else
				{
					if (++selectedIndex > maxIndex)
					{
						selectedIndex = 0;
					}
					this.setState({selectedIndex});
				}
				handled = true;
				break;
			case "ArrowUp":
				handled = true;
				if (expanded)
				{
					if (--selectedIndex <= -1)
					{
						selectedIndex = maxIndex;
					}
					this.setState({selectedIndex});
				}
				break;
			case "Tab":
			case "Enter":
				if (expanded)
				{
					const toSelect = this.state.shownOptions[selectedIndex];
					this.props.onSelect(toSelect);
				}
				break;
			case "Escape":
				handled = true;
				if (this.state.expanded)
				{
					bubbleToPropsKeyDown = false;
				}
				this.setState({expanded: false});
				break;
		}

		if (handled)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		if (_.isFunction(this.props.onKeyDown) && bubbleToPropsKeyDown)
		{
			this.props.onKeyDown(event);
		}
	}

	componentWillReceiveProps(nextProps)
	{
		this.setState({ description: nextProps.value || "", expanded: false });
	}

	componentWillMount()
	{
		this.fetchShownOptions = _.debounce(this.fetchShownOptions, 500);
	}

	componentWillUnmount()
	{
		this.fetchShownOptions.cancel();
		const requestsToCancel = [].concat(this._outstandingRequests);
		this._outstandingRequests = [];
		for (let index = 0; index < requestsToCancel.length; ++index)
		{
			requestsToCancel[index].cancel();
		}
	}

	render()
	{
		const description = this.state.description;
		const lowerValue = description.toLowerCase();
		const options = this.state.shownOptions;
		const selectedIndex = this.state.selectedIndex;

		return (
			<div>
				<div className={classNames("descriptionComplete", this.state.dropUp ? "dropup" : "dropdown", {open: this.state.expanded})}>
					<FormControl
						type="text"
						className={classNames("form-control input-sm", this.props.className)}
						placeholder="Description"
						value={description}
						onChange={this.handleTextFieldChange}
						onFocus={this.handleFocus}
						onBlur={this.handleBlur}
						onKeyDown={this.handleKeyDown}
						ref={(input) => this.textInput = input}
						autoFocus={this.props.autoFocus}
					/>
					<ul className="dropdown-menu">
						{options && options.map((option, index) => {
							const isSelected = index === selectedIndex;
							let anchor;

							if (description)
							{
								const matchIndex = option.description.toLowerCase().indexOf(lowerValue);
								anchor = <a>{option.description.substr(0, matchIndex)}<u>{option.description.substr(matchIndex, description.length)}</u>{option.description.substr(matchIndex + description.length)}</a>;
							}
							else
							{
								anchor = <a>{option.description}</a>;
							}

							return (
								<li key={option.id} className={isSelected ? "active" : ""} style={{cursor: "pointer"}} onMouseDown={this.handleOptionSelect.bind(this, option)}>
									{anchor}
								</li>
							);
						})}
					</ul>
				</div>
			</div>
		);
	}
}

DescriptionComplete.defaultProps = {
	onBlur: () => {},
	onFocus: () => {}
};

DescriptionComplete.propTypes = {
	value: PropTypes.string,
	className: PropTypes.string,
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
	onBlur: PropTypes.func,
	onKeyDown: PropTypes.func,
	onSelect: PropTypes.func,
	autoFocus: PropTypes.bool
};



// WEBPACK FOOTER //
// ./Components/components/DescriptionComplete.jsx